<template>
  <div>
    <div class="my-4">
      <Message :payload="payload" :additional_data="{ resource_type: 'Alert', endpoint: '/alerts/', headers: 'admin_headers' }" />
    </div>
    <OfferStatus v-if="offer" :payload="offer" buttonClass="offer-status-button"></OfferStatus>
  </div>
</template>
<script>
import OfferStatus from '@/components/OfferStatus'
import Message from '@/components/Message'

export default {
  name: 'position-offers-report',
  components: {
    OfferStatus,
    Message
  },
  props: {
    payload: {
      type: Object
    }
  },
  data () {
    return {
      offer: null
    }
  },
  created () {
    this.$network_utils
      .getOfferBy({
        applicant_id: this.payload.resources.applicant.resource_id,
        position_id: this.payload.resources.position.id
      })
      .then(response => {
        this.offer = response[0]
      })
  }
}
</script>
